/* eslint-disable camelcase */
export default {
  empty: 'Ни одной ссылки не добавлено в компонент слайдера',
};
